export enum OutputElementEnum {
  STRING = 'string',
  URL = 'url',
  EMAIL = 'email',
  PHONE_NUMBER = 'phoneNumber',
}
